module.exports = __webpack_public_path__ + "static/img/end.1bbd6ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Clocks/end.jpg
// module id = OF0E
// module chunks = 1